import { FC } from 'react'
import Link from 'next/link'
import styles from './AreaCard.module.scss'

interface Props {
  name: string
  imageUrl?: string
  href: string
}

const AreaCard: FC<Props> = ({ name, imageUrl, href }: Props): JSX.Element => {
  imageUrl = imageUrl != null && imageUrl !== '' ? imageUrl : '/location_popular_area_default.webp'

  const style = {
    backgroundImage: `url(${imageUrl})`,
  }

  return (
    <a href={href} className={styles.link} style={style}>
      <span className={styles.linkText}>{name}</span>
    </a>
  )
}

export default AreaCard
